import { CHERRY_DEV } from '../CherrySoftware/cherryDevBrand';

export { CHERRY_DEV };

/** Paleta técnica / automotriz: carbón, acero, cerámica hidrofóbica */
export const NASIOL = {
  carbon: '#0F1419',
  carbonDeep: '#080B0F',
  steel: '#1C2A38',
  steelSoft: '#2A3F54',
  ceramic: '#1FA8B8',
  ceramicSoft: '#3FC4D4',
  mist: '#E9EEF3',
  mistDeep: '#D5DEE8',
  accent: '#E8A84A',
  accentSoft: '#F0C57A',
  ink: '#121820',
  inkMuted: '#4A5A6A',
  white: '#FFFFFF',
  // aliases usados por componentes (compat con estructura Guomei)
  ocean: '#1C2A38',
  oceanDeep: '#0F1419',
  lagoon: '#1FA8B8',
  lagoonSoft: '#3FC4D4',
  sand: '#E9EEF3',
  sandDeep: '#D5DEE8',
  sunset: '#E8A84A',
  sunsetSoft: '#F0C57A',
};

const BRAND_NAME = 'cherryDev';
const CLIENT_NAME = 'Nasiol Venezuela';
const CLIENT_CONTACT = 'Carlos';

export const WHATSAPP_PHONE =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_CHERRY_SOFTWARE_WHATSAPP_PHONE) ||
  '';

export const WHATSAPP_WEB_DEFAULT = `Hola ${BRAND_NAME}, soy ${CLIENT_CONTACT} de ${CLIENT_NAME}. Revisé la propuesta del catálogo online ($160) y envío el 50% de arranque + comprobante + link de Drive (compartido con karolscript@gmail.com).`;

export const WHATSAPP_ADS_DEFAULT = `Hola ${BRAND_NAME}, soy ${CLIENT_CONTACT} de ${CLIENT_NAME}. Quiero cotizar el plan de redes sociales para Nasiol Venezuela.`;

export const buildAdsPlanWhatsApp = (planName) =>
  `Hola ${BRAND_NAME}, soy ${CLIENT_CONTACT} de ${CLIENT_NAME}. Quiero el plan ${planName} de redes sociales. ¿Me confirman alcance, inicio y forma de pago?`;

export const PAGE_TITLE = `${BRAND_NAME} × ${CLIENT_NAME} | Catálogo online y redes`;
export const PAGE_DESCRIPTION =
  'Propuesta cherryDev para Nasiol Venezuela: catálogo web administrable ($160, dominio y hosting 1er año) y paquetes mensuales de redes. Sectores automotriz, marítimo e industrial.';

export const WEB_PAGE_TITLE = `${BRAND_NAME} × ${CLIENT_NAME} | Catálogo online`;
export const WEB_PAGE_DESCRIPTION =
  'Propuesta cherryDev para Nasiol Venezuela: catálogo administrable con líneas automotriz, marítima e industrial, WhatsApp para cotizar, dominio y hosting. Inversión $160 USD · 50% arranque / 50% entrega.';

export const ADS_PAGE_TITLE = `${BRAND_NAME} × ${CLIENT_NAME} | Redes sociales`;
export const ADS_PAGE_DESCRIPTION =
  'Propuesta de manejo de redes para Nasiol Venezuela: paquetes mensuales Esencial, Pro e Integral. Pauta Ads aparte.';

export const WEB_HERO_IMAGE =
  'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=1920&q=80';

export const ADS_HERO_IMAGE =
  'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=1920&q=80';

export const LINKS = {
  web: '/propuesta/nasiol#ecommerce',
  ads: '/propuesta/nasiol#publicidad',
};

export const webHero = {
  brand: BRAND_NAME,
  clientName: CLIENT_NAME,
  clientContact: CLIENT_CONTACT,
  overline: 'Propuesta formal · Catálogo online / e-commerce',
  title: 'Tu catálogo técnico, listo para cotizar.',
  subtitle:
    'Plataforma administrable para que el visitante identifique rápido qué solución necesita —automotriz, marítima o industrial—, vea el producto y pase a WhatsApp a pedir información o cotización.',
  cta: 'Ver estructura e inversión',
  congrats: `Claro que sí, ${CLIENT_CONTACT}.`,
};

export const webStructure = {
  overline: 'Plataforma',
  title: 'Estructura del catálogo Nasiol Venezuela',
  subtitle:
    'Diseño técnico y profesional alineado a la marca: no solo mostrar productos, sino orientar al cliente hacia la solución correcta y el contacto comercial.',
  modules: [
    {
      id: 'home',
      title: 'Página principal',
      text:
        'Presentación de Nasiol Venezuela con identidad técnica, profesional e innovadora. Primer impacto claro para quien llega desde Instagram, Facebook o WhatsApp.',
    },
    {
      id: 'catalogo',
      title: 'Catálogo de productos',
      text:
        'Carga inicial de los productos que ustedes nos proporcionen (o Excel para subida masiva). Cada ítem puede incluir nombre, descripción, imágenes, características y aplicación.',
    },
    {
      id: 'categorias',
      title: 'Categorías y líneas',
      text:
        'Organización por categorías o líneas de aplicación, con secciones diferenciadas para automotriz, marítimo e industrial.',
    },
    {
      id: 'comercial',
      title: 'Enfoque comercial',
      text:
        'El visitante identifica qué solución necesita, para qué sector aplica y cómo contactar a Nasiol para solicitar información o cotización.',
    },
    {
      id: 'whatsapp',
      title: 'WhatsApp estratégico',
      text:
        'Botones de contacto directo ubicados para facilitar el paso de consultar un producto a conversar con ustedes.',
    },
    {
      id: 'admin',
      title: 'Panel administrable',
      text:
        'Panel intuitivo para agregar productos, categorías, aplicaciones o nuevas secciones sin comenzar de cero. Te dejamos ejemplos y te enseñamos a usarlo.',
    },
    {
      id: 'crecimiento',
      title: 'Lista para crecer',
      text:
        'Estructura preparada para sumar distribuidores, casos de uso u otras secciones cuando el negocio lo pida.',
    },
  ],
};

export const webInvestment = {
  overline: 'Inversión',
  title: 'Catálogo online, precio cerrado',
  subtitle: 'Oferta especial mantenida: dominio y hosting incluidos el primer año.',
  lines: [
    {
      id: 'platform',
      label: 'Catálogo online / web administrable',
      amount: 150,
    },
    { id: 'hosting', label: 'Dominio y hosting (1er año)', amount: 10 },
  ],
  total: 160,
  currency: 'USD',
  note: 'Sin cobros sorpresa en el primer año de dominio y hosting.',
  paymentSchedule: {
    title: 'Forma de pago',
    items: [
      { id: 'start', label: '50% para iniciar', amount: 80 },
      { id: 'delivery', label: '50% al entregar', amount: 80 },
    ],
  },
};

export const payment = {
  overline: 'Formalización',
  title: 'Métodos de pago',
  subtitle: 'Toca Copiar en el dato que necesites. Queda listo en el portapapeles.',
  methods: [
    {
      id: 'zelle',
      name: 'Zelle',
      fields: [{ label: 'Correo', value: 'loreanaquino53@gmail.com' }],
    },
    {
      id: 'binance',
      name: 'Binance',
      fields: [{ label: 'Correo / Pay ID', value: 'karolyntno@gmail.com' }],
    },
    {
      id: 'zinli',
      name: 'Zinli',
      fields: [{ label: 'Correo', value: 'karolyntno@gmail.com' }],
    },
    {
      id: 'pagomovil',
      name: 'Pago Móvil (Bs a tasa promedio)',
      fields: [
        {
          label: 'Datos completos',
          value: 'Karolyn Méndez · CI 166444576 · 04123964576 · Banesco',
        },
      ],
    },
  ],
};

export const webNextSteps = {
  overline: 'Siguientes pasos',
  title: 'Así formalizamos y arrancamos',
  subtitle:
    'Con el 50% de arranque y el material en Drive, Nasiol Venezuela entra en producción.',
  driveEmail: 'karolscript@gmail.com',
  steps: [
    {
      id: 'pago',
      n: '01',
      title: '50% de arranque + comprobante',
      text:
        'Realiza el 50% inicial ($80 USD) y envíanos el comprobante por WhatsApp para activar el proyecto.',
    },
    {
      id: 'drive',
      n: '02',
      title: 'Sube todo el material a Google Drive',
      text:
        'Crea una carpeta con el material de Nasiol Venezuela, compártela con karolscript@gmail.com y pásanos el link por WhatsApp.',
      materials: [
        'Logo en alta calidad (PNG/SVG preferible)',
        'Manual de marca, si lo tienes (colores, tipografías, usos del logo)',
        'Fotografías de productos, aplicaciones y resultados (antes/después si aplica)',
        'Listado de productos (Excel ideal) con características, aplicación y categorías',
        'Organización por líneas: automotriz, marítimo e industrial',
        'Textos técnicos y promesa de marca',
        'WhatsApp de cotizaciones, teléfono, correo y redes',
        'Ubicación / horarios si aplican atención presencial o showroom',
        'Banners o piezas de campañas actuales, si ya las tienen',
      ],
    },
    {
      id: 'arranque',
      n: '03',
      title: 'Confirmación, desarrollo y 50% final',
      text:
        'Con el pago y el Drive arrancamos. Al entregar la web lista, se cancela el 50% restante ($80 USD).',
    },
  ],
  cta: 'Enviar comprobante por WhatsApp',
  copyright: `© ${new Date().getFullYear()} ${BRAND_NAME} · Propuesta para ${CLIENT_NAME}`,
};

export const adsHero = {
  brand: BRAND_NAME,
  clientName: CLIENT_NAME,
  overline: 'Redes para proteger y cotizar',
  title: 'Educan. Demuestran. Convierten.',
  subtitle:
    'Planes mensuales claros para coatings nanotecnológicos. Respuesta a mensajes incluida. Tráfico hacia tu catálogo y WhatsApp.',
  cta: 'Ver planes',
};

export const adsFactors = {
  overline: 'En pocas palabras',
  title: 'Qué hace subir o bajar el plan',
  items: [
    { id: 'platforms', title: 'Cuántas redes' },
    { id: 'volume', title: 'Foto vs video' },
    { id: 'community', title: 'Respuesta a mensajes' },
    { id: 'assets', title: 'Quién da el material' },
    { id: 'ads', title: 'Ads aparte' },
  ],
};

export const adsPackages = {
  overline: 'Planes',
  title: 'Tres ritmos. Un objetivo: cotizaciones B2B y retail.',
  subtitle: 'Todos incluyen respuesta a mensajes en horario comercial.',
  plans: [
    {
      id: 'esencial',
      name: 'Esencial',
      tag: 'Presencia',
      price: 140,
      priceNote: '/mes',
      featured: false,
      focus: 'Marca activa y educación de producto.',
      cta: 'Quiero Esencial',
      stats: [
        { label: 'Redes', value: 'IG + FB' },
        { label: 'Pubs', value: '12/mes' },
        { label: 'Ritmo', value: '3/sem' },
      ],
      features: [
        'Carruseles técnicos y demos cortas',
        'Copy a WhatsApp o catálogo',
        'Hashtags auto / detailing / industria',
        'Respuesta a mensajes incluida',
      ],
    },
    {
      id: 'pro',
      name: 'Pro',
      tag: 'Conversión',
      price: 280,
      priceNote: '/mes',
      featured: true,
      badge: 'Ideal',
      focus: 'Más video y prospectos a WhatsApp.',
      cta: 'Quiero Pro',
      stats: [
        { label: 'Redes', value: 'IG · TT · FB' },
        { label: 'Pubs', value: '16–20/mes' },
        { label: 'Stories', value: '3–5/sem' },
      ],
      features: [
        'Reels y TikToks de aplicación / hidrofobia',
        'Historias con líneas de producto y web',
        'DMs → WhatsApp comercial',
        'Reporte: alcance y clics al catálogo',
      ],
    },
    {
      id: 'integral',
      name: 'Integral',
      tag: 'Crecimiento',
      price: 390,
      priceNote: '/mes',
      featured: false,
      focus: 'Máxima presencia + seguimiento.',
      cta: 'Quiero Integral',
      stats: [
        { label: 'Redes', value: 'Hasta 4' },
        { label: 'Base', value: 'Todo Pro' },
        { label: 'Plus', value: 'Reunión/mes' },
      ],
      features: [
        'Más video y casos de uso por sector',
        'Calendario por campañas / lanzamientos',
        'CM activo + reporte ampliado',
        'Ads Meta/TikTok aparte',
      ],
    },
  ],
};

export const adsNotes = {
  overline: 'Importante',
  title: 'Tres reglas claras',
  items: [
    {
      id: 'sinergia',
      title: 'Redes + catálogo',
      text:
        'Las redes educan y abren la necesidad; tu catálogo online cierra la cotización.',
    },
    {
      id: 'material',
      title: 'Material',
      text:
        'Si aportan fotos/videos de aplicaciones reales, el fee se mantiene. Producción nuestra se cotiza aparte.',
    },
    {
      id: 'pauta',
      title: 'Ads',
      text:
        'La inversión la pagan a Meta/TikTok. Gestión: +$100–150/mes o % del spend.',
    },
  ],
};

export const adsFinal = {
  overline: 'Siguiente paso',
  title: '¿Arrancamos con qué plan?',
  subtitle: 'WhatsApp para confirmar inicio. El catálogo potencia todo.',
  cta: 'Hablar por WhatsApp',
  webCta: 'Ver catálogo $160',
  copyright: `© ${new Date().getFullYear()} ${BRAND_NAME} · Redes para ${CLIENT_NAME}`,
};
